





































import Vue, { PropType } from 'vue'

import { Dictionary } from '../../../base/store/state.interface'
import { StatusData, UnitsItem } from '../../../typings/StatusData'

import { DateTimeService } from '../../../base/services/DateTimeService'
import BaseIcon from '../../../base/components/BaseIcon.vue'
import BaseTimeAgo from '../../../base/components/BaseTimeAgo.vue'
import { predefinedColumns } from './StatusDetail.widget'

export default Vue.extend({
  components: {
    BaseIcon,
    BaseTimeAgo
  },
  props: {
    showFullTime: {
      type: Boolean,
      default: false,
    },
    wbuuid: {
      type: String as PropType<string>,
      required: true,
    },
    widthColumns: {
      type: Object
    },
    dynamicWidthColumns: {
      type: Object
    },
    unit: {
      type: Object as PropType<UnitsItem>,
    },
    isHeader: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    columnsSorting: {
      type: Array as PropType<any[]>,
      required: true
    },
    qualifications: {
      type: Array as PropType<any[]>,
      required: true
    }
  },
  computed: {
    mappedQualifications() {
      const unitQualifications = this.unit?.qualifications || []
      let mappedQualifications = unitQualifications.filter((elem: number) => {
        return this.qualifications.includes(elem.toString())
      })

      return mappedQualifications
    },
  },
  methods: {
    getQualificationShortname(id: number | string) {
      return this.$store.getters.getQualificationShortname(id.toString())
    },
    getVehicleName(id: number) {
      return id !== 0 ? this.$store.state.cluster.vehicle[id].name : ''
    },
    getRowClasses(key: string) {
      const rowClasses = [`status-detail-column__${key}`]

      if (this.qualifications.includes(key)) rowClasses.push('status-detail-column__qualification')

      return rowClasses
    },
    formatTime(ts: number) {
      return DateTimeService.formatUnixTimestamp(ts)
    }
  }
})
